<div>
    <app-sidebar></app-sidebar>
    <div class="main-content transition d-flex flex-column" [ngClass]="{ active: isSidebarToggled }"
        [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()">
        <app-header></app-header>
        <app-applicant-admin-dashboard></app-applicant-admin-dashboard>
        <div class="flex-grow-1"></div>
        <app-footer></app-footer>
    </div>
</div>